import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdministrationAccess } from '../layout/navigation/useAdministrationAccess';

/**
 * Guards /administration — visible when Administration grouping is on and the user
 * has access to at least one back-office module (same rules as the sidebar group).
 */
function RequireAdministrationAccess({ children }) {
  const { menusLoaded, canAccess } = useAdministrationAccess();

  if (!menusLoaded) {
    return (
      <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading access...</span>
        </div>
      </div>
    );
  }

  if (!canAccess) {
    return <Navigate to="/app" replace />;
  }

  return children;
}

export default RequireAdministrationAccess;
